export default "__VITE_ASSET__pIRYb2zn__"